export default "__VITE_ASSET__D$L0o0oU__"